module.exports = "pegasus/assets/circle-instagram.png";